import { Clickable } from '@prisjakt/ui/clickable';
import styled from 'styled-components';

export const EditorContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  z-index: 106; /* When no longer component, use zindex.menu.experimentEditor */
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background: rgba(247, 248, 248, 1);
  height: 50px;
  width: 50px;
`;

export const ToggleButton = styled(Clickable)`
  border-radius: 25px;
  position: absolute;
  left: 0.75rem;
  top: 0rem;
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -1;
  width: 100vw;
  height: 50px;
  overflow-x: auto;
  overscroll-behavior: contain;
  background: ${p => p.theme.bg.secondary};
  padding: 8px 8px 8px 50px;
  padding-right: 50px;

  > button {
    margin-left: 10px;
  }
`;
